import { IConfiguration } from '../../../../domain/conf'
import { IIdentityServiceAdapter } from '../adapter'

interface IWindow extends Window {
    MG2Loader: any
    pageTag: string
}

interface INavigaPlugin {
    name: string
    initOptions: any
}

export enum PaywallLevel {
    NOT_METERED = 'not_metered',
    METERED = 'metered',
    REGISTRATION_LOCKED = 'registration_locked',
    PREMIUM_LOCKED = 'premium_locked',
}

declare let window: IWindow

export class NavigaAuth0Adapter implements IIdentityServiceAdapter {
    private fingerprintPlugin: INavigaPlugin
    private g2InsightsPlugin: INavigaPlugin
    private engagePlugin: INavigaPlugin

    constructor(private pageData: IConfiguration) {
        const auth0Config = pageData.identity?.auth0
        const navigaConfig = pageData.identity?.naviga

        // Naviga plugin configurations
        // tslint:disable-next-line:max-line-length
        // Reference: https://docs.navigaglobal.com/engage/-MGi9-KKLwnWfoD36Ot6/getting-started-with-engage/configuring-engage-on-your-website/setting-up-the-inititalization-script#initialization-script-options
        if (auth0Config && navigaConfig) {
            this.fingerprintPlugin = {
                initOptions: {
                    environment: navigaConfig.environment || '',
                    version: navigaConfig.fingerprint?.version || '',
                },
                name: 'FP',
            }

            this.g2InsightsPlugin = {
                initOptions: {
                    collectors: navigaConfig.g2Insights?.collectors || [],
                    containerId: navigaConfig.g2Insights?.containerId || '',
                    tagManager: navigaConfig.g2Insights?.tagManager || '',
                    version: navigaConfig.g2Insights?.version || '',
                },
                name: 'DL',
            }

            this.engagePlugin = {
                initOptions: {
                    authSettings: {
                        // Auth0 configurations
                        client_id: auth0Config.clientId || '',
                        domain: auth0Config.domain || '',
                        redirect_uri: `${location.origin}/auth0-redirect/`,
                    },
                    clientCode: navigaConfig.engage?.clientCode || '',
                    configCode: navigaConfig.engage?.configCode || '',
                    debug: navigaConfig.debug || false,
                    environment: navigaConfig.environment || '',
                    publicEventHandlers: {
                        // List of Naviga Engage events:
                        // https://docs.navigaglobal.com/engage/-MGi9-KKLwnWfoD36Ot6/fundamentals/engage-events
                        onInit: NavigaAuth0Adapter.handleOnInitEvent,
                    },
                    siteCode: navigaConfig.engage?.siteCode || '',
                },
                name: 'NXT',
            }
        }
    }

    /**
     * On init event - Remove sign in loader
     */
    public static handleOnInitEvent() {
        // remove sign in loader
        const signInLoader = document.querySelector('.sso-btns .sign-in-spinner')
        signInLoader.remove()
    }

    /**
     * Initalize Naviga plugins
     */
    public init() {
        if (window.MG2Loader) {
            // load Naviga plugins
            window.MG2Loader.init(
                {
                    plugins: [
                        this.fingerprintPlugin,
                        this.g2InsightsPlugin,
                        this.engagePlugin
                    ]
                }
            )
        }

        // add paywall level page tag
        this.setPaywallLevel()
    }

    /**
     * Check if there is an auth0_sub cookie
     */
    public hasSession(): boolean {
        const auth0Cookie = (document.cookie.split(';').find((c) =>
                c.trim().startsWith('auth0_sub')) || '').trim().split('=').pop() || undefined
        return !!auth0Cookie
    }

    /**
     * Define paywall level base on page data
     */
    public setPaywallLevel() {
        const page = this.pageData.page
        let pageTag: string

        if (page) {
            if (page.isPremium) {
                // premium locked
                pageTag = PaywallLevel.PREMIUM_LOCKED
            } else if (page.isRegistration) {
                // registration only
                pageTag = PaywallLevel.REGISTRATION_LOCKED
            } else if (page.isPaywallWhitelisted) {
                // non-metered content
                pageTag = PaywallLevel.NOT_METERED
            } else {
                // metered content
                pageTag = PaywallLevel.METERED
            }

            window.pageTag = pageTag
        }
    }
}
